import Cookies from "js-cookie";

// The marketing site doesn't handle login itself — it only reads the
// cross-subdomain cookie that the app (book.barbersunity.com) sets on
// login, so a customer/barber who's already logged in sees the right
// nav state here too.

export let Auth = {
  getUser() {
    const user = Cookies.get("user");
    return user ? JSON.parse(user) : null;
  },
  getToken() {
    let user = Auth.getUser();
    return user && user.token ? user.token : false;
  },
  authenticated() {
    let user = Auth.getUser();
    return user && user.token ? true : false;
  },
  logout() {
    Cookies.remove('user', { domain: '.barbersunity.com' });
    if (window.location.pathname === '/') {
        window.location.reload();
    } else {
        window.location.href = '/';
    }
},
};
